import React, { useEffect, useState } from 'react';
import { useStore } from '../../contexts/StoreProvider';
import { Link } from 'react-router-dom';

const StoreScreen = () => {
  const { products, categories, fetchProducts, fetchCategories, isLoading } = useStore();
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  useEffect(() => {
    fetchCategories();
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCategorySelect = (categoryId) => {
    setSelectedCategoryId(categoryId);
    fetchProducts(categoryId);
  };

  return (
    <div className="flex flex-col">
      
      {/* Header Section */}
      <div className="mb-16">
        <div className="flex justify-between items-end border-b border-[#13110E]/10 pb-10">
          <h1 className="text-5xl md:text-7xl font-serif text-[#13110E] leading-none">
            The Store
          </h1>
          <div className="text-right pb-2">
            <span className="font-serif italic text-lg md:text-xl text-[#13110E]/80 block">
              {products.length === 1 ? 'One piece' : `${products.length} pieces`}
            </span>
          </div>
        </div>
      </div>

      {/* Filters and Sort Row */}
      <div className="flex justify-between items-center mb-10 text-[9px] tracking-[0.25em] uppercase font-medium">
        <div className="flex space-x-8 overflow-x-auto scrollbar-hide pb-2">
          <button
            onClick={() => handleCategorySelect(null)}
            className={`transition-colors whitespace-nowrap ${
              selectedCategoryId === null
                ? 'text-[#13110E] border-b border-[#13110E] pb-1'
                : 'text-[#13110E]/50 hover:text-[#13110E]'
            }`}
          >
            ALL ITEMS
          </button>
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => handleCategorySelect(cat.id)}
              className={`transition-colors whitespace-nowrap ${
                selectedCategoryId === cat.id
                  ? 'text-[#13110E] border-b border-[#13110E] pb-1'
                  : 'text-[#13110E]/50 hover:text-[#13110E]'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
        <div className="flex-shrink-0 ml-4 hidden sm:block">
          <button className="flex items-center text-[#13110E]/60 hover:text-[#13110E] transition-colors">
            SORT <span className="ml-2 text-[#13110E]">NEWEST ∨</span>
          </button>
        </div>
      </div>

      {/* Product Grid */}
      {isLoading ? (
        <div className="flex justify-center items-center py-32">
          <div className="w-10 h-10 border border-[#13110E] border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : products.length === 0 ? (
        <div className="text-center py-32 font-serif italic text-xl text-[#13110E]/60">
          No pieces available at the moment.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-16 gap-x-8">
          {products.map((product, index) => {
            return (
              <Link 
                to={`/store/product/${product.id}`} 
                key={product.id} 
                className="group flex flex-col"
              >
                {/* Image Container */}
                <div className="relative bg-[#E5DFD5] overflow-hidden mb-4 aspect-[4/5]">
                  {product.images && product.images.length > 0 ? (
                    <img
                      src={product.images[0].image}
                      alt={product.name}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700 ease-out"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-[#13110E]/30 font-serif italic">
                      No Image
                    </div>
                  )}
                </div>
                
                {/* Product Details (Border top) */}
                <div className="border-t border-[#13110E]/10 pt-4 flex flex-col">
                  <div className="flex justify-between items-start mb-2 text-[9px] tracking-[0.2em] uppercase text-[#13110E]/60">
                    <span>
                      {String(index + 1).padStart(2, '0')} · {product.category_detail?.name || 'AFRICAN WEAR'}
                    </span>
                    <span className="font-serif tracking-normal text-sm flex flex-col items-end">
                      <span className="text-[#13110E]">
                        ₵{parseFloat(product.price).toFixed(2)}
                      </span>
                      {product.was_price && (
                        <span className="line-through text-gray-400 text-xs mt-0.5">
                          ₵{parseFloat(product.was_price).toFixed(2)}
                        </span>
                      )}
                    </span>
                  </div>
                  <h3 className="font-serif text-2xl text-[#13110E] mt-1 group-hover:opacity-70 transition-opacity">
                    {product.name}
                  </h3>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StoreScreen;
